module.exports = __webpack_public_path__ + "media/bootstrap-icons/question-circle-fill-2d16243c.svg";